import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, message, Tooltip } from 'antd';
import ReactJson from 'react-json-view';
import './index.less';
import * as api from '@/services/initial';
import { FullScreen } from '@/components';
import { getStatus, getDurationTime, formatTime } from '@/utils/utils';
let timerId1: any = null;
let timerId2: any = null;
const StatusDetails = () => {
  const { taskId } = useParams();
  const myRef = useRef<HTMLDivElement>({} as HTMLDivElement);
  const myRef2 = useRef<HTMLDivElement>({} as HTMLDivElement);
  const [detailObj, setDetailObj] = useState<TaskItemType>({} as TaskItemType);
  const [dataSource, setDataSource] = useState<TaskResultItemType[]>([]);
  const [logList, setLogList] = useState<LogItemType[]>([]);
  const [isShow, setShow] = useState<boolean>(false);
  useEffect(() => {
    getTaskDetails();
    getResultByTaskId();
    return () => {
      clearTimeout(timerId1);
      clearTimeout(timerId2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);
  useEffect(() => {
    if (!!logList.length) {
      clearTimeout(timerId2);
      timerId2 = setTimeout(() => {
        myRef?.current?.scrollIntoView();
      }, 0);
    }
  }, [logList.length]);
  useEffect(() => {
    getLogByTaskId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(detailObj)]);
  const getTaskDetails = async () => {
    const res = await api.getTaskDetails(taskId as string);
    if (res?.success) {
      setDetailObj(res.data.details);
    }
  };
  const getResultByTaskId = async () => {
    const res = await api.getResultByTaskId(taskId as string);
    if (res?.success) {
      setDataSource(res.data.details);
    }
  };
  const getLogByTaskId = async () => {
    const res = await api.getLogByTaskId(taskId as string);
    if (res?.success) {
      setLogList(res.data?.details?.logs || []);
      if (res.data?.details?.status === 4) {
        clearTimeout(timerId1);
        timerId1 = setTimeout(() => {
          getLogByTaskId();
        }, 5000);
      } else {
        clearTimeout(timerId1);
        getTaskDetails();
        getResultByTaskId();
      }
    }
  };

  const downloadFile = async (fileId: string) => {
    message.info('请稍等，正在导出文件');
    const res = await api.getStorageFileUrl(fileId);
    if (res.success) {
      const a = document.createElement('a');
      a.href = res?.data?.details;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleClick = (id: string) => {
    downloadFile(id);
  };
  const columns = [
    {
      title: '源类型',
      dataIndex: 'fileType',
      key: 'fileType',
    },
    {
      title: '目标类型',
      dataIndex: 'outputType',
      key: 'outputType',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      key: 'createAt',
    },
    {
      title: '操作',
      dataIndex: 'address',
      key: 'address',
      render: (_: any, row: TaskResultItemType) => {
        return (
          <div className="action-box">
            <span onClick={() => handleClick(row.storageFileId)}>下载</span>
          </div>
        );
      },
    },
  ];
  const handleTransfer = async (id: string) => {
    const res = await api.retryTransfer(id);
    if (res.success) {
      window.location.reload();
    } else {
      message.error('重新转换失败，请再次尝试');
    }
  };
  return (
    <div className="details-box">
      <div className="status-details">
        <div className="left">
          <div className="title">
            基本信息
            {detailObj.logStorageFileId && (
              <span className="action" onClick={() => handleClick(detailObj.logStorageFileId)}>
                日志下载
              </span>
            )}
            {detailObj.storageFileId && (
              <span className="action" onClick={() => handleClick(detailObj.storageFileId)}>
                源文件下载
              </span>
            )}
            {[1, 2, 3, 5].includes(detailObj.status) && detailObj.id && (
              <span className="action" onClick={() => handleTransfer(detailObj.id)}>
                重新转换
              </span>
            )}
          </div>
          <div className="top">
            <div className="item">
              <span className="title">文件名称:</span>
              <Tooltip title={detailObj?.fileName}>
                <span className="tip">{detailObj?.fileName}</span>
              </Tooltip>
            </div>
            <div className="item">
              <span className="title">创建时间:</span>
              <span className="tip">{detailObj?.createAt}</span>
            </div>
            <div className="item">
              <span className="title">开始时间:</span>
              <span className="tip">{formatTime(detailObj?.startTime)}</span>
            </div>
            <div className="item">
              <span className="title">结束时间:</span>
              <span className="tip">{formatTime(detailObj?.endTime)}</span>
            </div>
            <div className="item">
              <span className="title">花费时间:</span>
              <span className="tip">
                {getDurationTime(detailObj?.startTime, detailObj?.endTime)}
              </span>
            </div>
            <div className="item">
              <span className="title">输出类型:</span>
              <span className="tip">{detailObj?.outputType}</span>
            </div>
            <div className="item">
              <span className="title">文件ID:</span>
              <span className="tip">{detailObj?.storageFileId}</span>
            </div>
            <div className="item">
              <span className="title">应用名称:</span>
              <span className="tip">{detailObj?.appName}</span>
            </div>
            <div className="item">
              <span className="title">转换状态:</span>
              <span className="tip">{getStatus(detailObj?.status)}</span>
            </div>
            <div className="item">
              <span className="title">业务Id:</span>
              <span className="tip">{detailObj?.businessId}</span>
            </div>
            <div className="item">
              <span className="title">任务Id:</span>
              <span className="tip">{detailObj?.id}</span>
            </div>
            <div className="item">
              <span className="title">文件后缀:</span>
              <span className="tip">{detailObj?.suffix}</span>
            </div>
          </div>
          <div className="json-box">
            <ReactJson src={detailObj.params ? JSON.parse(detailObj.params) : {}} theme="google" />
          </div>
          <div className="title">成果列表</div>
          <div className="bottom">
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
        <div
          className="right"
          ref={myRef2}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
        >
          <div>
            {logList.map((log: LogItemType, index: number) => {
              if (index === logList.length - 1) {
                return (
                  <div key={index} ref={myRef}>
                    {log.msg}
                  </div>
                );
              } else {
                return <div key={index}>{log.msg}</div>;
              }
            })}
          </div>
          {(detailObj?.status === 4 || detailObj?.status === 0) && (
            <div className="loading-box">
              <div className="loading-item"></div>
              <div className="loading-item"></div>
              <div className="loading-item"></div>
              <div className="loading-item"></div>
              <div className="loading-item"></div>
            </div>
          )}
          {isShow && <FullScreen el={myRef2} customClass="custom-class" />}
        </div>
      </div>
    </div>
  );
};

export default StatusDetails;
